import React from 'react';

/**
 * A venue's website in the contact block.
 *
 * Owners paste whatever their browser gave them, which is often a long deep
 * link. Printed raw it has no spaces to break on, so it pushes the column —
 * and with it the page — wider than it should be. Here the host is what gets
 * shown, since that is the part a reader recognises, and the full URL stays in
 * the link itself.
 */

const normalize = (raw) => {
  const value = String(raw || '').trim();
  if (!value) return null;
  // Owners rarely type the scheme; assume https so the link still works
  const withScheme = /^[a-z][a-z0-9+.-]*:\/\//i.test(value) ? value : `https://${value}`;
  try {
    return new URL(withScheme);
  } catch {
    return null;
  }
};

/** What to print: the host, plus a hint when the link goes deeper than that. */
export const formatWebsite = (raw) => {
  const url = normalize(raw);
  if (!url) return String(raw || '').trim();

  const host = url.hostname.replace(/^www\./i, '');
  const path = url.pathname.replace(/\/+$/, '');

  if (!path) return host;

  // A short path is worth showing in full; a long one only gets a marker
  const full = `${host}${path}`;
  return full.length <= 38 ? full : `${host}/…`;
};

export const websiteHref = (raw) => {
  const url = normalize(raw);
  return url ? url.href : String(raw || '').trim();
};

export default function ContactWebsite({ url }) {
  const value = String(url || '').trim();
  if (!value) return null;

  return (
    <a
      className='review-contact-text review-contact-link'
      href={websiteHref(value)}
      target='_blank'
      rel='noreferrer'
      title={value}
    >
      {formatWebsite(value)}
    </a>
  );
}
